module.exports = __webpack_public_path__ + "static/img/B (28).31fa62e1.png";